<app-pharm-header></app-pharm-header>

<div class="container">
  <app-pharm-sidebar></app-pharm-sidebar>

  <div class="patients-header">
    <h2>👥 Manage Patients</h2>
    <div class="action-buttons">
      <button (click)="showPatientModal = true">➕ Add Patient</button>
    </div>
  </div>

  <!-- 🔹 Feedback Toast -->
  <div *ngIf="feedbackMessage" class="toast" [ngClass]="feedbackType">
    {{ feedbackMessage }}
  </div>

  <!-- 🔹 Patient Modal -->
  <div class="modal-backdrop" *ngIf="showPatientModal">
    <div class="modal large">
      <h3>{{ editingId ? 'Edit Patient' : 'Register Patient' }}</h3>
      <form (ngSubmit)="submit()" class="modal-form">
        <input type="text" placeholder="Surname" [(ngModel)]="form.surname" name="surname" required />
        <input type="text" placeholder="Other Names" [(ngModel)]="form.other_names" name="other_names" required />
        <input type="text" placeholder="Sex" [(ngModel)]="form.sex" name="sex" required />
        <input type="number" placeholder="Age" [(ngModel)]="form.age" name="age" required />
        <input type="text" placeholder="Hospital ID" [(ngModel)]="form.hospital_id" name="hospital_id" required />
        <input type="text" placeholder="Allergic (optional)" [(ngModel)]="form.allergic" name="allergic" />
        <input type="text" placeholder="Phone" [(ngModel)]="form.phone" name="phone" required />
        <input type="email" placeholder="Email" [(ngModel)]="form.email" name="email" required />
        <select [(ngModel)]="form.type" name="type" required>
          <option value="out-patient">Out-patient</option>
          <option value="in-patient">In-patient</option>
        </select>
        <select [(ngModel)]="form.company_id" name="company_id">
          <option [ngValue]="null">-- Select Company (optional) --</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>
        <select [(ngModel)]="form.ward_id" name="ward_id" *ngIf="form.type === 'in-patient'" required>
          <option [ngValue]="null">-- Select Ward --</option>
          <option *ngFor="let ward of wards" [ngValue]="ward.id">{{ ward.name }}</option>
        </select>
        <div class="modal-actions">
          <button type="submit">{{ editingId ? 'Update' : 'Add' }}</button>
          <button class="cancel" type="button" (click)="resetForm(); showPatientModal = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <!-- 🔹 Filters -->
  <div class="filters">
    <input type="text" [(ngModel)]="filters.surname" placeholder="Filter by Surname" />
    <input type="text" [(ngModel)]="filters.other_names" placeholder="Filter by Other Names" />
    <input type="text" [(ngModel)]="filters.sex" placeholder="Filter by Sex" />
    <input type="text" [(ngModel)]="filters.hospital_id" placeholder="Filter by Hospital ID" />
    <input type="text" [(ngModel)]="filters.phone" placeholder="Filter by Phone" />
    <input type="text" [(ngModel)]="filters.email" placeholder="Filter by Email" />
    <select [(ngModel)]="filters.type">
      <option value="">All Types</option>
      <option value="in-patient">In-patient</option>
      <option value="out-patient">Out-patient</option>
    </select>
    <select [(ngModel)]="filters.ward_id">
      <option value="">All Wards</option>
      <option *ngFor="let ward of wards" [ngValue]="ward.id">{{ ward.name }}</option>
    </select>
    <button (click)="resetFilters()">❌ Clear Filters</button>
    <button (click)="exportToCSV()">📤 Export CSV</button>
  </div>

  <!-- 🔹 Patient Table -->
  <div *ngIf="loading">⏳ Loading patients...</div>

  <table class="patient-table" *ngIf="!loading">
    <thead>
      <tr>
        <th>Surname</th>
        <th>Other Names</th>
        <th>Sex</th>
        <th>Age</th>
        <th>Hospital ID</th>
        <th>Phone</th>
        <th>Email</th>
        <th>Type</th>
        <th>Ward</th>
        <th>Company</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of paginatedPatients; trackBy: trackById">
  <td><span class="label">Surname:</span> {{ p.surname }}</td>
  <td><span class="label">Other Names:</span> {{ p.other_names }}</td>
  <td><span class="label">Sex:</span> {{ p.sex }}</td>
  <td><span class="label">Age:</span> {{ p.age }}</td>
  <td><span class="label">Hospital ID:</span> {{ p.hospital_id }}</td>
  <td><span class="label">Phone:</span> {{ p.phone }}</td>
  <td><span class="label">Email:</span> {{ p.email }}</td>
  <td><span class="label">Type:</span> {{ p.type }}</td>
  <td><span class="label">Ward:</span> {{ p.type === 'in-patient' ? getWardName(p.ward_id) : 'N/A' }}</td>
  <td><span class="label">Company:</span> {{ getCompanyName(p.company_id) }}</td>
  <td>
    <button (click)="edit(p); showPatientModal = true;">✏️</button>
    <button (click)="delete(p.id)">🗑️</button>
    <button (click)="viewDetails(p.id)">🔍</button>
  </td>
</tr>

    </tbody>
  </table>

  <div class="pagination">
    <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">⬅️ Prev</button>
    <span>Page {{ currentPage }}</span>
    <button (click)="currentPage = currentPage + 1" [disabled]="currentPage * pageSize >= filteredPatients.length">Next ➡️</button>
  </div>
</div>
